/**
 * The tools a Hire connects to, shown in the "works with" section. Shared
 * between the hire-agent landing (control) and the film landing (treatment)
 * so both A/B arms list the same integrations. Logos live in
 * public/logos/<file>.
 */
export interface Integration {
  name: string;
  file: string;
}

export const INTEGRATIONS: Integration[] = [
  { name: "Gmail", file: "gmail.svg" },
  { name: "Google Calendar", file: "google-calendar.svg" },
  { name: "Google Drive", file: "google-drive.svg" },
  { name: "Slack", file: "slack.svg" },
  { name: "Telegram", file: "telegram.svg" },
  { name: "Microsoft Teams", file: "microsoft-teams.svg" },
];
